<template>
  <div class="col-12 p-0 peelHuntScren">
    <!-- <fullscreen ref="fullscreen" :fullscreen.sync="isFullScreen"> -->
    <!--Table-->
    <PeelHuntLoaderVue
      v-if="peelhuntLoader"
      :title="LoaderTitle"
    ></PeelHuntLoaderVue>
    <div class="col-12" ref="capture">
      <b-row>
        <div class="tblWrapper">
          <div class="tableContainer p-2">
            <div class="col-12 mb-2 position-relative">
              <b-row>
                <div
                  class="col-12 p-0 SectorKendoTableWrapper"
                  v-if="sectorDropDown"
                >
                  <SectorKendoTableWrapper
                    :tableColumns="sectorTableColumns"
                    :tableData="sectorTableData"
                    :sectorDropDown="sectorDropDown"
                    :SelectedValueDropDown="SelectedValue"
                    @getSectorTableData="getSectorTableData"
                    @selectedSectorValue="selectedSectorValue"
                    @sectorKendoTableData="sectorKendoTableData"
                    @applySectorFilter="applySectorFilter"
                    @peelHuntLoaderValue="peelHuntLoaderValue"
                    @allTableDataExportEmit="allTableDataExport"
                    :pulseLoader="pulseLoader"
                    :customIndexTableData="customIndexTableData"
                    :allExportButtonToggel="pulseLoader"
                    :hideSectorMessage="hideSectorMessage"
                  ></SectorKendoTableWrapper>
                </div>
              </b-row>
            </div>
            <div
              class="col-12 p-0 customindex"
              v-if="customIndexDropDown.length > 0"
            >
              <customindex
                :customIndexDropDown="customIndexDropDown"
                :finalSectorKendoTableData="finalSectorKendoTableData"
                :customIndexTableData="customIndexTableData"
                @customIndexPayLoad="customIndexPayLoad"
                :selectedBenchMarkNameTitle="selectedBenchMarkName"
                :pulseLoader="pulseLoader"
              ></customindex>
            </div>
            <div class="col-12 p-0 PricePerformanceTableData">
              <PricePerformance
                :tableData="PricePerformanceTableData"
                :tableColumns="PricePerformanceTableColumns"
                :switchButton="true"
                :tableTitle="'Price performance (%)'"
                @pricePerformanceToggel="pricePerformanceToggel"
                :pulseLoader="pulseLoader.pricePerformance"
                :compId="'PricePerformanceId'"
              ></PricePerformance>
            </div>
            <div class="col-12 p-0 RiskAdjustedTableData">
              <PricePerformance
                :tableData="RiskAdjustedReturnTableData"
                :tableColumns="RiskAdjustedReturnTableColumns"
                :switchButton="false"
                :tableTitle="'Risk Adjusted Return'"
                @pricePerformanceToggel="pricePerformanceToggel"
                :pulseLoader="pulseLoader.RiskAdjusted"
                :compId="'RiskAdjustedReturnId'"
              ></PricePerformance>
            </div>
          </div>
        </div>
      </b-row>
    </div>
    <!-- </fullscreen> -->
  </div>
</template>
<script>
// import "@progress/kendo-ui";
import {
  Grid,
  GridToolbar,
  filterGroupByField,
  sortGroupByField,
  GridColumnMenuSort,
} from "@progress/kendo-vue-grid";
import { process } from "@progress/kendo-data-query";
import "@progress/kendo-theme-default/dist/all.css";
import { Input } from "@progress/kendo-vue-inputs";
// import fullscreen from "vue-fullscreen";
// import Vue from "vue";
// Vue.use(fullscreen);
import { DropDownList } from "@progress/kendo-vue-dropdowns";
import { mapActions, mapGetters } from "vuex";
// import { MultiSelect } from "@progress/kendo-dropdowns-vue-wrapper";
// import multiselectDropDown from "./MultiSelect";
import Customindex from "./Peel_Hunt_Component/Custom_index.vue";
import SectorKendoTableWrapper from "./Peel_Hunt_Component/SectorKendoTableWrapper.vue";
// import SectorKendoTableWrapper2 from "./Peel_Hunt_Component/SectorKendoTableWrapper2.vue";
import PricePerformance from "./Peel_Hunt_Component/PricePerformance.vue";
import DownloadIcon from "../../assets/img/Download_icon.svg";
import FullScreen from "../../assets/img/icons/svg/full_screen.svg";
import Products from "./Peel_Hunt_Component/data.json";
import PeelHuntLoaderVue from "./Peel_Hunt_Component/PeelHuntLoader.vue";
import {
  saveExcel,
  workbookOptions,
  toDataURL,
} from "@progress/kendo-vue-excel-export";
import { saveAs } from "@progress/kendo-file-saver";
import Vue from "vue";
import VueToast from "vue-toast-notification";
import "vue-toast-notification/dist/theme-sugar.css";
Vue.use(VueToast);

export default {
  name: "Peel_Hunt",
  components: {
    // Grid: Grid,
    // toolbar: GridToolbar,
    // "k-input": Input,
    // dropdownlist: DropDownList,
    // "kendo-multiselect": MultiSelect,
    // multiselectDropDown: multiselectDropDown,
    customindex: Customindex,
    PricePerformance: PricePerformance,
    // GridColumnMenuSort: GridColumnMenuSort,
    SectorKendoTableWrapper: SectorKendoTableWrapper,
    // SectorKendoTableWrapper2: SectorKendoTableWrapper2,
    PeelHuntLoaderVue,
  },
  data: function() {
    return {
      DownloadIcon,
      FullScreen,
      isFullScreen: false,
      SelectedValue: {},
      source: [],
      sectorTableColumns: [],
      sectorTableData: [],
      sectorDropDown: [],
      PricePerformanceTableData: [],
      PricePerformanceTableColumns: [],
      RiskAdjustedReturnTableData: [],
      RiskAdjustedReturnTableColumns: [],
      customIndexDropDown: [],
      finalSectorKendoTableData: [],
      customIndexPayLoadData: {},
      sectorTableAppliedFilter: [],
      customIndexTableData: {},
      RiskAdjustedReturn: "",
      selectedBenchMarkName: "",
      peelhuntLoader: false,
      pulseLoader: {
        customeIndex: {
          table: false,
          chart: false,
          data: false,
        },
        pricePerformance: {
          table: false,
          data: false,
        },
        RiskAdjusted: {
          table: false,
          data: false,
        },
      },
      LoaderTitle: "Please wait Loading...",
      pricePerformanceStickyRow: [],
      riskAdjustmentStickyRow: [],
      hideSectorMessage: true,
    };
  },
  computed: {
    ...mapGetters({}),
  },
  watch: {},
  methods: {
    ...mapActions([
      "getPeelhuntSectorsData",
      "getPeelhuntTableData",
      "customIndexAPIHandler",
      "getCustomIndexDropdown",
      "getPricePerformanceToggel",
      "getRiskAdjustedTableData",
    ]),
    getToken() {
      let authToken = "";
      if (
        this._routerRoot._route.query &&
        this._routerRoot._route.query.auth_token
      ) {
        authToken = this._routerRoot._route.query.auth_token;
      }
      return authToken;
    },
    // get sector data form API here
    async getSectorsDropDownList() {
      this.peelhuntLoader = true;
      // get sector by API, uncomment this code and hit the API
      let response = await this.getPeelhuntSectorsData({
        auth_token: this.getToken(),
        data: "peelhunt",
      });
      this.$nextTick(() => {
        if (response.length) {
          this.sectorDropDown = response.length ? response : [];
          this.peelhuntLoader = false;
          this.SelectedValue = {};
          this.SelectedValue = this.sectorDropDown[0];
          this.getPeelhuntSectorTableData(this.SelectedValue);
        } else {
          this.showToast(response.response.data.Message, "warning");
          this.peelhuntLoader = false;
        }
      });
    },
    // on change sector this method trigger
    selectedSectorValue(val) {
      this.SelectedValue = {};
      this.$nextTick(() => {
        this.SelectedValue = val;
      });
      // this.getPeelhuntSectorTableData(this.SelectedValue);
    },
    async getSectorTableData(value) {
      this.peelhuntLoader = true;
      await this.getPeelhuntSectorTableData(value);
      await this.getCustomIndexDropdownDataHandler(false);
      this.peelhuntLoader = false;
    },
    applySectorFilter(data) {
      this.sectorTableAppliedFilter = [];
      this.sectorTableAppliedFilter = data;
    },
    async getPeelhuntSectorTableData(SelectedValue) {
      this.peelhuntLoader = true;
      // console.log("------------------->>", this.peelhuntLoader);
      this.LoaderTitle = "Please Wait... <br />Sector Data Loading...";
      // get sector table data by API, uncomment this code and hit the API
      let response = await this.getPeelhuntTableData(SelectedValue);
      // this data bind form API
      this.sectorTableColumns = [];
      this.sectorTableData = [];
      this.PricePerformanceTableData = [];
      this.PricePerformanceTableColumns = [];
      this.RiskAdjustedReturnTableData = [];
      this.RiskAdjustedReturnTableColumns = [];
      if (response.table_data && response.table_column) {
        this.$nextTick(() => {
          this.sectorTableColumns = response.table_column
            ? response.table_column
            : [];
          // if (response.table_data && response.table_data.length) {
          // response.table_data.forEach((data) => {
          //   data["Market cap(m)"] = Number(data["Market cap(m)"].replaceAll(",", ""));
          // });
          // }
          this.sectorTableData = response.table_data ? response.table_data : [];
          this.customIndexPayLoadData = {};
          this.sectorTableAppliedFilter = [];
          this.peelhuntLoader = false;
        });
      } else {
        this.showToast(response.response.data.Message, "warning");
      }
      // console.log("------------------->>222", this.peelhuntLoader);
    },
    // get visible rows table data form sector kendo table
    sectorKendoTableData(value) {
      // console.log("sectorKendoTableData", value);
      this.finalSectorKendoTableData = value.data;
    },
    peelHuntLoaderValue(value) {
      this.peelhuntLoader = value;
      if (this.peelhuntLoader) {
        this.LoaderTitle = "Please Wait... <br />Sector Data Loading...";
      } else {
        this.LoaderTitle = "";
      }
    },
    // get custom drop down data here
    async getCustomIndexDropdownDataHandler(value) {
      this.peelhuntLoader = true;
      if (value) {
        let response = await this.getCustomIndexDropdown({
          auth_token: this.getToken(),
          data: "peelhunt",
        });
        this.customIndexDropDown = [];
        this.$nextTick(() => {
          this.customIndexTableData = {};
          // console.log("getCustomIndexDropdownDataHandler", response);
          if (response && response.length) {
            this.customIndexDropDown = response ? response : [];
          } else {
            this.showToast(response.response.data.Message, "warning");
          }
        });
      } else {
        let deepCopy = JSON.parse(JSON.stringify(this.customIndexDropDown));
        this.customIndexDropDown = [];
        this.$nextTick(() => {
          this.customIndexTableData = {};
          this.customIndexDropDown = deepCopy;
          this.peelhuntLoader = false;
        });
      }
    },
    // get custom index all dropdown selected value and it will update data on change dropdown value
    async customIndexPayLoad(payLoadVal) {
      let payLoad = JSON.parse(JSON.stringify(payLoadVal));
      // just for testing risk adjustment key delete
      this.RiskAdjustedReturn = JSON.parse(
        JSON.stringify(payLoad.RiskAdjusted)
      );
      let benchMarkName = JSON.parse(JSON.stringify(payLoad.selectedBenchMark));
      delete payLoad.RiskAdjusted;
      delete payLoad.selectedBenchMark;
      if (this.SelectedValue.SectorID) {
        let sectorTableFilterList = JSON.parse(
          JSON.stringify(this.sectorTableAppliedFilter)
        );
        let notIncludeFilter = ["market cap(m)", "upside/downside"];
        sectorTableFilterList = sectorTableFilterList.filter((fList) => {
          return notIncludeFilter.indexOf(fList.FieldName.toLowerCase()) < 0;
        });
        if (sectorTableFilterList.length > 0) {
          this.customIndexPayLoadData = {};
          this.customIndexPayLoadData = payLoad;
          // console.log("payLoad+++++", payLoad);
          this.customIndexPayLoadData.SectorID = this.SelectedValue.SectorID;
          this.customIndexPayLoadData.ColumnFilter = [...sectorTableFilterList];
          this.pulseLoader.customeIndex.table = true;
          this.pulseLoader.customeIndex.chart = true;
          this.pulseLoader.pricePerformance.table = true;
          this.pulseLoader.RiskAdjusted.table = true;
          this.selectedBenchMarkName = "";
          this.selectedBenchMarkName = "Custom Index v/s " + benchMarkName;
          await this.customIndexApply(this.customIndexPayLoadData);
          this.pulseLoader.customeIndex.table = false;
          this.pulseLoader.customeIndex.chart = false;
        } else {
          this.showToast(
            `Please set criteria to screen companies; it will be used to calculate Custom index using backtesting approach.
            <br/>(<span class="text-uppercase">C</span>ompany, <span class="text-uppercase">T</span>icker, <span class="text-uppercase">R</span>ecommendation, <span class="text-uppercase">M</span>arket <span class="text-uppercase">C</span>ap, <span class="text-uppercase">U</span>pside /<span class="text-uppercase">D</span>ownside columns will be excluded, while calculating <span class="text-uppercase">C</span>ustom index.)`,
            "warning"
          );
        }
      } else {
        this.showToast("Please select sector.", "warning");
      }
    },
    async customIndexApply(data) {
      this.hideSectorMessage = true;
      this.$nextTick(() => {
        this.hideSectorMessage = false;
      });
      // getting price performance/risk adjusted return table data
      this.PricePerformanceTableData = [];
      this.PricePerformanceTableColumns = [];
      this.RiskAdjustedReturnTableData = [];
      this.RiskAdjustedReturnTableColumns = [];
      this.customIndexTableData = {};
      this.pulseLoader.customeIndex.data = false;
      this.pulseLoader.pricePerformance.data = false;
      this.pulseLoader.RiskAdjusted.data = false;
      let response = await this.customIndexAPIHandler(data);
      this.pulseLoader.customeIndex.table = false;
      this.pulseLoader.customeIndex.chart = false;
      this.$nextTick(() => {
        if (response.table_column && response.table_data) {
          this.customIndexTableData = response;
          this.pulseLoader.customeIndex.data = true;
        } else {
          this.showToast(response.response.data.Message, "warning");
          this.pulseLoader.customeIndex.data = false;
        }
      });
      if (response.table_column && response.table_data) {
        // price performance api call simultaniously
        await this.pricePerformanceToggel(false, "custome_index");
      } else {
        this.pulseLoader.pricePerformance.table = false;
        this.pulseLoader.RiskAdjusted.table = false;
      }
    },
    // on change price performance toggle this event trigger
    async pricePerformanceToggel(data, value) {
      // this.peelhuntLoader = true;
      this.pulseLoader.pricePerformance.table = true;
      // console.log("dataaaaaa", data);
      await this.getPricePerformanceToggelHandler(data, value);
      // this.peelhuntLoader = false;
    },
    // on change price performance toggel button get the toggel value and then set payload for API
    async getPricePerformanceToggelHandler(payLoad, value) {
      this.LoaderTitle = "Please Wait... <br />Price Performance Loading...";
      // payload for on change price performance toggel button
      // console.log("this.customIndexPayLoadData", this.customIndexPayLoadData);
      // console.log("payLoad+++++++++", payLoad);
      if (
        this.customIndexPayLoadData.BenmarkIndex &&
        this.customIndexPayLoadData.CorpId
      ) {
        let obj = {
          BenmarkIndex: this.customIndexPayLoadData.BenmarkIndex,
          CorpId: this.customIndexPayLoadData.CorpId,
          IsRelativeReturn: payLoad,
        };
        this.PricePerformanceTableData = [];
        this.PricePerformanceTableColumns = [];
        // console.log("Toggel object", obj);
        let response = await this.getPricePerformanceToggel(obj);
        // console.log("responsegetPricePerformanceToggel", response);
        this.$nextTick(() => {
          if (response.table_data && response.table_column) {
            this.pulseLoader.pricePerformance.data = true;
            this.PricePerformanceTableData = response.table_data;
            this.PricePerformanceTableColumns = response.table_column;
            let columnClone = [];
            columnClone = JSON.parse(
              JSON.stringify(this.PricePerformanceTableColumns)
            );
            let last2ObjectsFromTables = [
              this.PricePerformanceTableData[
                this.PricePerformanceTableData.length - 2
              ],
              this.PricePerformanceTableData[
                this.PricePerformanceTableData.length - 1
              ],
            ];
            this.pricePerformanceStickyRow = this.PricePerformanceTableData.splice(
              this.PricePerformanceTableData.length - 2,
              2
            );
            for (let i = 0; i < columnClone.length; i++) {
              let width = columnClone[i].field.length * 8 + 6 + 16 + 20;
              columnClone[i].children = [
                {
                  title: last2ObjectsFromTables[0][columnClone[i].field],
                  width: width + "px",
                  children: [
                    {
                      field: columnClone[i].field,
                      title: last2ObjectsFromTables[1][columnClone[i].field],
                      width: width + "px",
                    },
                  ],
                },
              ];
            }
            this.PricePerformanceTableColumns = [...columnClone];
            this.pulseLoader.pricePerformance.table = false;
          } else {
            this.pulseLoader.pricePerformance.data = false;
            this.pulseLoader.pricePerformance.table = true;
            // console.log("---------", response.response.data.Message);
            this.showToast(response.response.data.Message, "warning");
          }
        });
        if (
          value === "custome_index" &&
          response.table_data &&
          response.table_column
        ) {
          this.LoaderTitle = "Please Wait... <br />Risk Adjustment Loading...";
          // risk adjustment api call simultaniously
          await this.getRiskAdjustedTableDataHandler(this.RiskAdjustedReturn);
        }
      } else {
        this.showToast("Please select required fields", "warning");
      }
      // this.PricePerformanceTableData = Products[0].pricePerformance[0]
      //   .table_data
      //   ? Products[0].pricePerformance[0].table_data
      //   : [];
      // this.PricePerformanceTableColumns = Products[0].pricePerformance[0]
      //   .table_column
      //   ? Products[0].pricePerformance[0].table_column
      //   : [];
    },
    // on change risk adjustment then get data form API
    async getRiskAdjustedTableDataHandler(payLoad) {
      // payload data for risk adjustment
      let obj = {
        BenmarkIndex: this.customIndexPayLoadData.BenmarkIndex,
        CorpId: this.customIndexPayLoadData.CorpId,
        RiskFreeRate: payLoad,
      };
      // console.log("Toggel object RiskAdjustedReturn", obj);
      let response = await this.getRiskAdjustedTableData(obj);
      // console.log("RiskAdjustedReturn=====>", response);
      this.$nextTick(() => {
        if (response.table_data && response.table_column) {
          this.pulseLoader.RiskAdjusted.data = true;
          this.RiskAdjustedReturnTableData = response.table_data;
          this.RiskAdjustedReturnTableColumns = response.table_column;

          let columnClone = [];
          columnClone = JSON.parse(
            JSON.stringify(this.RiskAdjustedReturnTableColumns)
          );
          let last2ObjectsFromTables = [
            this.RiskAdjustedReturnTableData[
              this.RiskAdjustedReturnTableData.length - 2
            ],
            this.RiskAdjustedReturnTableData[
              this.RiskAdjustedReturnTableData.length - 1
            ],
          ];
          this.riskAdjustmentStickyRow = this.RiskAdjustedReturnTableData.splice(
            this.RiskAdjustedReturnTableData.length - 2,
            2
          );
          for (let i = 0; i < columnClone.length; i++) {
            let width = columnClone[i].field.length * 8 + 6 + 16 + 20;
            columnClone[i].children = [
              {
                title: last2ObjectsFromTables[0][columnClone[i].field],
                width: width + "px",
                children: [
                  {
                    field: columnClone[i].field,
                    title: last2ObjectsFromTables[1][columnClone[i].field],
                    width: width + "px",
                  },
                ],
              },
            ];
          }
          this.RiskAdjustedReturnTableColumns = [...columnClone];
          this.pulseLoader.RiskAdjusted.table = false;
        } else {
          this.pulseLoader.RiskAdjusted.data = false;
          this.pulseLoader.RiskAdjusted.table = true;
          // console.log("---------", response.response.data.Message);
          this.showToast(response.response.data.Message, "warning");
        }
      });
      // this.peelhuntLoader = false;
      // this.RiskAdjustedReturnTableData = Products[0].RiskAdjustedReturn[0]
      //   .table_data
      //   ? Products[0].RiskAdjustedReturn[0].table_data
      //   : [];
      // this.RiskAdjustedReturnTableColumns = Products[0].RiskAdjustedReturn[0]
      //   .table_column
      //   ? Products[0].RiskAdjustedReturn[0].table_column
      //   : [];
    },
    allTableDataExport(data) {
      let date = new Date();
      const day = String(date.getDate()).padStart(2, "0");
      const month = String(date.getMonth() + 1).padStart(2, "0");
      const year = date.getFullYear();
      let fileName = "Detailed Stock screener " + `${day}${month}${year}`;
      this.customSaveExcel({
        data: data.data,
        fileName: fileName,
        columns: data.columns,
      });
    },
    customSaveExcel: function(exportOptions) {
      const saveFn = (dataURL) => {
        saveAs(dataURL, exportOptions.fileName);
      };
      // console.log("this.customIndexTableData", this.customIndexTableData);
      const sectorData = workbookOptions(exportOptions);
      const customIndexData = workbookOptions({
        data: this.customIndexTableData.table_data,
        fileName: "All Export",
        columns: this.customIndexTableData.table_column,
      });
      let priceTableData = [
        ...this.pricePerformanceStickyRow,
        ...this.PricePerformanceTableData,
      ];
      let riskTableData = [
        ...this.riskAdjustmentStickyRow,
        ...this.RiskAdjustedReturnTableData,
      ];
      const priceData = workbookOptions({
        data: priceTableData,
        fileName: "All Export",
        columns: this.PricePerformanceTableColumns,
      });
      const riskData = workbookOptions({
        data: riskTableData,
        fileName: "All Export",
        columns: this.RiskAdjustedReturnTableColumns,
      });
      // console.log("options", sectorData);
      sectorData.sheets[0].name = "Sector";
      customIndexData.sheets[0].name = "Custom Index";
      priceData.sheets[0].name = "Price performance";
      riskData.sheets[0].name = "Risk Adjustment";
      sectorData.sheets.push(customIndexData.sheets[0]);
      sectorData.sheets.push(priceData.sheets[0]);
      sectorData.sheets.push(riskData.sheets[0]);
      toDataURL(sectorData).then(saveFn);
    },
    // show toast----
    showToast(message, type) {
      let showMessage = message
        .toLowerCase()
        .toString()
        .replace(/(^|\. *)([a-z])/g, function(match, separator, char) {
          return separator + char.toUpperCase();
        });
      this.$toast.open({
        message: showMessage,
        type: type,
        duration: 3000,
        dismissible: true,
        position: "top",
      });
    },
  },
  mounted() {
    this.getSectorsDropDownList();
    this.getCustomIndexDropdownDataHandler(true);
  },
  beforeDestroy() {},
  created() {
    // this.getSectorsDropDownList();
    // this.getCustomIndexDropdownDataHandler(true);
    // this.getPricePerformanceToggelHandler({});
    // this.getRiskAdjustedTableDataHandler({});
  },
};
</script>
<style lang="scss">
@import "./primeicons-master/primeicons.css";

$peelhunt-theme-color: #462b61;
$peelhunt-btn-color: #00b4b1;
$peelhunt-border-color: #ced4da;
$peelhunt-border-color: #ced4da;
@font-face {
  font-family: ArchivoRegular;
  src: url(../../assets/peelhunt-fonts/Archivo-Regular.ttf);
}
@font-face {
  font-family: "Archivo-Bold";
  src: url(../../assets/peelhunt-fonts/Archivo-Bold.ttf);
}
.k-animation-container.k-animation-container-relative {
  * {
    font-size: 12px;
  }
}
.peelHuntScren,
.k-animation-container.k-animation-container-relative {
  background-color: #f6f6f6;
  html,
  head,
  title,
  meta,
  link,
  style,
  script,
  noscript,
  body,
  header,
  nav,
  main,
  article,
  section,
  aside,
  footer,
  p,
  a,
  img,
  video,
  audio,
  source,
  track,
  iframe,
  table,
  caption,
  thead,
  tbody,
  tr,
  th,
  td,
  ul,
  ol,
  li,
  dl,
  dt,
  dd,
  blockquote,
  q,
  cite,
  abbr,
  code,
  pre,
  em,
  strong,
  mark,
  small,
  sub,
  sup,
  del,
  ins,
  hr,
  br,
  wbr,
  form,
  input,
  button,
  select,
  textarea,
  label,
  fieldset,
  legend,
  optgroup,
  option,
  progress,
  meter,
  details,
  summary,
  menu,
  command,
  output,
  canvas,
  svg,
  math,
  div,
  span,
  header,
  nav,
  main,
  article,
  section,
  aside,
  footer,
  figure,
  figcaption,
  time,
  data,
  mark,
  ruby,
  rt,
  rp,
  bdi,
  bdo,
  map,
  area,
  script,
  noscript,
  embed,
  object,
  param,
  iframe,
  frame,
  frameset,
  noframes,
  hgroup,
  track,
  source,
  video,
  audio,
  canvas,
  progress,
  meter,
  time,
  data,
  mark,
  ruby,
  rt,
  rp,
  bdi,
  bdo,
  wbr {
    font-family: ArchivoRegular;
  }
  th,
  h1,
  h2,
  h3,
  h4,
  h5,
  h6 {
    font-family: "Archivo-Bold";
  }
  .font_size_12 {
    font-size: 12px !important;
  }
  .dropSearchAlign .k-picker {
    min-width: 200px;
    max-width: 200px;
    border-radius: 5px;
    height: 36px !important;
  }
  .k-grid-header .k-sort-icon,
  .k-grid-header .k-sort-order {
    color: $peelhunt-theme-color;
    margin-inline-end: 7px;
  }
  // .k-animation-container-relative {
  //   width: 100% !important;
  // }
  .k-widget.k-dropdown {
    // border: 1px solid #ccc;
    padding-right: 10px;
    // background: #fff;
    height: 35px;
    max-height: 35px;
    border-radius: 4px;
    overflow: hidden;
    .k-dropdown-wrap {
      height: 35px;
      display: flex;
      flex-direction: row;
      align-content: center;
      flex-wrap: nowrap;
      align-items: center;
      vertical-align: middle;
      background: transparent;
      border: 1px solid #ccc;
      overflow: hidden;
      border-radius: 5px;
      padding-left: 10px;
      background-color: #fff;
      .k-select {
        padding-right: 10px;
      }
      .k-input {
        // justify-content: center;
        align-items: center;
        border: none;
        background: #fff;
      }
    }
  }
  .tblWrapper {
    max-height: 97vh !important;
    margin-bottom: 0px;
    padding-bottom: 0px;
    overflow-x: hidden;
    overflow-y: auto;
    .tableContainer {
      // background: #fff;
      border-radius: 5px;
      box-shadow: unset;
      .vertical-align {
        display: flex;
        flex-direction: row;
        flex-wrap: nowrap;
        align-content: center;
        justify-content: space-between;
        align-items: center;
        .dropSearchAlign {
          display: flex;
          flex-direction: row;
          flex-wrap: nowrap;
          align-content: center;
          justify-content: flex-end;
          align-items: stretch;
        }
      }
      .k-grid-toolbar {
        border: none;
      }
      .peelhunt_kendo_table_wrapper {
        // .dropSearchAlign {
        //   margin: 0px 0 0px;
        // }
        .form-group {
          margin: 0px 0 0px;
          height: 27px;
        }
      }
      .form-group {
        margin: 20px 0 10px;
        height: auto;
      }
      .tableSearchInput {
        border-radius: 20px !important;
        z-index: 0;
        width: 250px;
        background: transparent;
        border: none;
        overflow: hidden;
        background: white;
        .k-textbox.k-input {
          border-radius: 0px !important;
          border: none;
          width: 100%;
        }
        input {
          border-radius: 0 !important;
          z-index: 0;
          padding-left: 0px;
          width: 100%;
        }
        .input-group-prepend {
          .input-group-text {
            background: transparent;
            border: none;
            z-index: 2;
            svg {
              height: 15px;
              width: 15px;
              color: #ccc;
            }
          }
        }
      }
      table {
        width: 100% !important;
        tr:nth-child(even) td {
          background-color: #f9f9f9 !important;
        }
        .k-svg-icon {
          color: #fff;
        }
      }
      .k-grid-header-wrap {
        border-top: 1px solid $peelhunt-btn-color;
        // border-right: 0px solid $peelhunt-border-color;
        border-bottom: 0px solid $peelhunt-border-color;
        border-left: 0px solid $peelhunt-border-color;
      }
      // .k-grid {
      //   border: none !important;
      // }
      .k-grid .k-grid-container {
        border-left: 1px solid $peelhunt-border-color;
        border-right: 1px solid $peelhunt-border-color;
        border-bottom: 1px solid $peelhunt-border-color;
      }
      .svg-inline--fa {
        color: $peelhunt-theme-color;
      }
      .input-group {
        height: 30px;
        width: unset;
      }
      .k-textbox:focus-within {
        box-shadow: none !important;
      }
      .k-widget.k-grid {
        width: 100% !important;
        border: none;
      }
      .k-grid-header {
        width: 100% !important ;
      }
      .k-grid-table {
        width: 100% !important;
      }
      .k-textbox:focus,
      .k-textbox.k-state-focus,
      .k-textbox.k-state-focused {
        border-color: none;
        box-shadow: none;
      }
      .k-grid th,
      .k-grid td {
        font-size: 12px;
        // max-width: 250px;
        border-top: 1px solid $peelhunt-border-color !important;
        border-right: 0px solid $peelhunt-border-color !important;
        border-bottom: 1px solid $peelhunt-border-color !important;
        border-left: 0px solid $peelhunt-border-color !important;
        background-color: #fff;
        // text-align: left;
        // padding-right: 35px;
      }
      .SectorKendoTableWrapper .k-grid-container {
        border-top: 0px solid #f6f6f6 !important;
        .k-grid td {
          border-top: 1px solid #f0f0f0 !important;
          border-right: 0px solid #f0f0f0 !important;
          border-bottom: 1px solid #f0f0f0 !important;
          border-left: 0px solid #f0f0f0 !important;
        }
      }
      .PricePerformanceTableData .k-grid td {
        font-size: 12px;
        // width: 250px;
        // border-top: 3px solid #f6f6f6 !important;
        border-right: 0px solid #f6f6f6 !important;
        // border-bottom: 3px solid #f6f6f6 !important;
        border-left: 0px solid #f6f6f6 !important;
        background-color: #fff;
        // text-align: left;
        padding-right: 25px;
        overflow: hidden;
        text-overflow: ellipsis;
        box-sizing: content-box;
      }
      thead tr.k-table-row:nth-child(2),
      thead tr.k-table-row:nth-child(3) {
        th {
          border-top: 1px solid $peelhunt-border-color !important;
          border-bottom: 1px solid $peelhunt-border-color !important;
        }
        th:nth-child(1) {
          border-left: 1px solid $peelhunt-border-color !important;
        }
        th:last-child {
          border-right: 1px solid $peelhunt-border-color !important;
        }
        // color: $peelhunt-border-color ;
      }
      thead tr.k-table-row:nth-child(3) {
        th {
          border-bottom: 2px solid $peelhunt-border-color !important;
        }
      }
      thead tr.k-table-row:nth-child(2) th span,
      thead tr.k-table-row:nth-child(3) th span {
        color: $peelhunt-theme-color;
      }
      .k-grid th {
        background-color: $peelhunt-btn-color;
        border-top: 1px solid $peelhunt-btn-color !important;
        border-right: 0px solid $peelhunt-btn-color !important;
        border-bottom: 1px solid $peelhunt-btn-color !important;
        border-left: 0px solid $peelhunt-btn-color !important;
      }
      .k-pager {
        background-color: #ffffff;
      }
      .k-alt,
      .k-pivot-layout > tbody > tr:first-child > td:first-child {
        background-color: #fff !important;
      }
      .k-i-more-vertical::before {
        content: url("../../assets/img/icons/svg/filter.svg") !important;
        width: 35px;
        margin-top: 7px;
      }
      .k-icon {
        color: $peelhunt-theme-color;
      }
      .k-icon.k-i-arrow-s::before {
        content: "\e015";
      }
      .k-grid-header .k-sort-order,
      .k-grid-header .k-header > .k-link {
        color: $peelhunt-theme-color;
      }
      .k-grid-header .k-i-sort-asc-sm,
      .k-grid-header .k-i-sort-desc-sm {
        color: #ccc;
      }
      .k-grid-content {
        overflow-y: auto !important;
      }
      .status-style {
        background: #fff;
        color: #fff;
        padding: 3px;
        white-space: nowrap;
        border-radius: 5px;
        width: 80px;
        max-width: 80px;
        display: inline-block;
        text-align: center;
        font-size: 12px;
        float: right;
      }
      .table-text-one-line {
        display: -webkit-box;
        -webkit-line-clamp: 1;
        -webkit-box-orient: vertical;
        overflow: hidden;
        max-height: 44px;
      }
      .k-grid-header {
        padding: 0 !important;
        col {
          // &:nth-of-type(1) {
          //   width: 250px;
          // }
          // &:nth-of-type(2) {
          //   width: 150px;
          // }
          // &:nth-of-type(3) {
          //   width: 250px;
          // }
          // &:nth-of-type(5) {
          //   max-width: 200px;
          // }
          // &:nth-of-type(7) {
          //   width: 80px;
          // }
        }
        .k-header {
          font-size: 12px !important;
          font-weight: bold;
          text-transform: unset;
          color: #fff;
          height: 16px;
          // min-width: 100px;
        }
        th.k-header.active > div > div {
          color: #fff;
          background-color: $peelhunt-theme-color;
        }
      }
      .k-grid-table {
        col {
          // &:nth-of-type(1) {
          //   width: 250px;
          // }
          // &:nth-of-type(2) {
          //   width: 150px;
          // }
          // &:nth-of-type(3) {
          //   width: 250px;
          // }
          // &:nth-of-type(5) {
          //   max-width: 200px;
          // }
          // &:nth-of-type(7) {
          //   width: 80px;
          // }
        }
      }
      .customTableHeadeButton .k-grid-column-menu.k-grid-filter {
        display: block;
        text-align: center;
      }
      .form-group {
        legend {
          color: #595959;
          position: absolute;
          top: -25px;
          left: 15px;
        }
      }
    }
  }
  .dropSearchAlign {
    ul.dropdown-menu.dropdown-menu-right.show,
    ul.dropdown-menu.dropdown-menu-right.show:hover {
      padding: 0 0 !important;
      border-radius: 0.25rem;
    }
    .disabled,
    [aria-disabled="true"] {
      cursor: not-allowed;
      img {
        opacity: 0.6;
      }
    }
    ul.dropdown-menu.dropdown-menu-right.show,
    ul.dropdown-menu.dropdown-menu-right.show::before {
      display: block;
      box-sizing: border-box;
    }
    ul.dropdown-menu.dropdown-menu-right.show::before {
      content: "";
      position: absolute;
      width: 10px;
      height: 10px;
      border-left: 1px solid;
      border-top: 1px solid;
      border-bottom: 1px solid transparent;
      transform: rotate(45deg) skew(10deg, 10deg);
      right: 11px;
      top: -6px;
      color: #d1d1d1;
    }
  }
  .dropdown.b-dropdown.btn-dropdown-style.downloadBtn.rounded-0.btn-group {
    height: 36px;
    button.btn.dropdown-toggle:focus,
    button.btn.dropdown-toggle.focus,
    button.btn.dropdown-toggle:hover,
    button.btn.dropdown-toggle {
      background-color: #fff !important;
      color: #000;
      border-radius: unset;
      padding: 0px 8px !important;
      border: none;
      border-color: rgba(0, 0, 0, 0.08);
      height: 36px;
      margin: 0 5px;
      width: 36px;
      img {
        width: 100%;
        height: 100%;
      }
    }
    .dropdown-item {
      padding: 5px 10px;
    }
  }
  .excel-btn-text-style {
    font-size: 14px;
    .excel-btn-second-text-style {
      font-size: 10px;
      text-wrap: wrap;
      width: 100%;
      display: block;
    }
  }
  button.btn-secondary:focus,
  button.btn-secondary.focus,
  .btn-secondary:hover,
  button.filterBtn {
    background-color: $peelhunt-btn-color;
    color: #fff;
    border-radius: 25px;
    padding: 6px 20px !important;
    height: 36px;
    margin: 0 10px;
    display: flex;
    align-items: center;
    border: 1px solid $peelhunt-btn-color;
    font-size: 14px;
    line-height: 20px;
  }
  button.filterBtn.column_filter {
    padding: 3px 15px !important;
  }
  button.downloadBtn,
  button.downloadBtn:hover,
  button.downloadBtn:active,
  button.downloadBtn:focus {
    background-color: #fff !important;
    color: #000;
    border-radius: unset;
    padding: 0px 8px !important;
    border: none;
    border-color: rgba(0, 0, 0, 0.08);
    height: 36px;
    margin: 0 5px;
    width: 36px;
    img {
      width: 100%;
      height: 100%;
    }
    &:hover {
      // background-color: #5a6268;
      background-color: #fff;
      border-color: #545b62;
      color: #000;
    }
  }
  .col-form-label {
    font-weight: 400 !important;
    font-size: 14px !important;
    padding-bottom: 5px !important;
    margin-left: -15px !important;
  }
  .k-pager-numbers .k-link:hover,
  .k-pager-numbers .k-link.k-state-hover {
    background: #e9ecef;
    border-color: transparent;
    color: #495057;
  }
  .k-pager-sizes.k-label {
    text-align: right;
    display: flex;
    justify-content: flex-end;
    flex: 4 1 0%;
  }
  .k-pager-numbers .k-link.k-state-selected {
    color: $peelhunt-theme-color;
    background-color: #fff;
  }
  .fullScreenIframe {
    position: absolute;
    top: 0;
    right: 0;
    z-index: 9999;
    height: 100vh;
    background: #fff;
    width: 100%;
  }
  div.fullscreen {
    padding: 15px;
    background: #f6f6f6 !important;
    z-index: 100;
  }
  .peelhunt_kendo_table_wrapper table.k-table.k-grid-header-table.k-table-md {
    thead.k-table-thead.k-grid-header {
      tr:nth-child(2) {
        th {
          background-color: #ffffff !important;
        }
      }
      tr:nth-child(3) {
        th {
          background-color: #f9f9f9 !important;
          .k-cell-inner {
            .k-sort-icon {
              display: none;
            }
          }
        }
      }
    }
  }
  .SectorKendoTableWrapper,
  .peelhunt_kendo_table_wrapper {
    .k-pager-sizes.k-label {
      color: #fff !important;
      span.k-dropdownlist.k-picker.k-picker-md.k-rounded-md {
        float: right;
        text-align: right;
        position: relative;
        left: 100px;
      }
    }
  }
  th.k-table-th.k-header {
    span.k-link::after {
      content: "";
      background-image: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAJCAYAAAAPU20uAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAyRpVFh0WE1MOmNvbS5hZG9iZS54bXAAAAAAADw/eHBhY2tldCBiZWdpbj0i77u/IiBpZD0iVzVNME1wQ2VoaUh6cmVTek5UY3prYzlkIj8+IDx4OnhtcG1ldGEgeG1sbnM6eD0iYWRvYmU6bnM6bWV0YS8iIHg6eG1wdGs9IkFkb2JlIFhNUCBDb3JlIDcuMS1jMDAwIDc5LmRhYmFjYmIsIDIwMjEvMDQvMTQtMDA6Mzk6NDQgICAgICAgICI+IDxyZGY6UkRGIHhtbG5zOnJkZj0iaHR0cDovL3d3dy53My5vcmcvMTk5OS8wMi8yMi1yZGYtc3ludGF4LW5zIyI+IDxyZGY6RGVzY3JpcHRpb24gcmRmOmFib3V0PSIiIHhtbG5zOnhtcD0iaHR0cDovL25zLmFkb2JlLmNvbS94YXAvMS4wLyIgeG1sbnM6eG1wTU09Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9tbS8iIHhtbG5zOnN0UmVmPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvc1R5cGUvUmVzb3VyY2VSZWYjIiB4bXA6Q3JlYXRvclRvb2w9IkFkb2JlIFBob3Rvc2hvcCAyMi41IChXaW5kb3dzKSIgeG1wTU06SW5zdGFuY2VJRD0ieG1wLmlpZDoyRUY2MDREMDQ1RTcxMUVDQUU2QzhFRDg3Mjg0QTA4RiIgeG1wTU06RG9jdW1lbnRJRD0ieG1wLmRpZDoyRUY2MDREMTQ1RTcxMUVDQUU2QzhFRDg3Mjg0QTA4RiI+IDx4bXBNTTpEZXJpdmVkRnJvbSBzdFJlZjppbnN0YW5jZUlEPSJ4bXAuaWlkOjJFRjYwNENFNDVFNzExRUNBRTZDOEVEODcyODRBMDhGIiBzdFJlZjpkb2N1bWVudElEPSJ4bXAuZGlkOjJFRjYwNENGNDVFNzExRUNBRTZDOEVEODcyODRBMDhGIi8+IDwvcmRmOkRlc2NyaXB0aW9uPiA8L3JkZjpSREY+IDwveDp4bXBtZXRhPiA8P3hwYWNrZXQgZW5kPSJyIj8+cfRkmgAAAH9JREFUeNpi+P//PwMUcwHxLiDeD2WDxWGSnEC8/j8CbIEpYgQSLAwMDKuBWAuIPwExiM8FxLeAOIgBqvMdEGsB8UqobjUgfg3EW5mAqt4BcSIQXwNicSAWgepOAOLXjGCHIMABIOYAYguYABMDAYCugBGK4YAFTcFPdBMAAgwAqQVhH6WAVl8AAAAASUVORK5CYII=);
      background-repeat: no-repeat;
      text-align: center;
      width: 9px;
      height: 9px;
      opacity: 0.5;
      margin-left: 3px;
    }
  }
  .customindex {
    th.k-table-th.k-header {
      span.k-link::after {
        display: none;
      }
    }
  }
  .k-grid-header .k-sorted .k-cell-inner > .k-link > .k-sort-icon,
  .k-grid-header .k-cell-inner > .k-link > .k-sort-icon {
    margin-inline-start: 3px !important;
    margin-inline-end: 0 !important;
  }
  th.k-table-th.k-header.k-sorted.k-filterable,
  th.k-table-th.k-header.k-sorted {
    span.k-link::after {
      content: "";
      background-image: unset;
      background-repeat: no-repeat;
      text-align: center;
      width: 9px;
      height: 9px;
      display: none;
    }
  }
}
#modal-sm {
  padding-right: 10px;
  overflow-y: hidden;
  label {
    border: 1px solid #ccc;
    padding: 10px;
    width: 100%;
    margin: 0 !important;
    margin-right: 0 !important;
    cursor: pointer;
  }
  .k-column-list {
    max-height: calc(100vh - 150px);
  }
  .k-column-list-item {
    padding: 5px;
    .k-checkbox:checked,
    .k-checkbox.k-checked {
      border-color: $peelhunt-theme-color;
      color: white;
      background-color: $peelhunt-theme-color;
      width: 15px;
      height: 15px;
      margin-right: 5px;
    }
    input[type="checkbox"] {
      width: 15px;
      height: 15px;
      margin-right: 5px;
    }
  }
}

// dropdown showing inside DOM before body--
.k-animation-container {
  height: auto !important;
  max-height: 450px !important;
}
.k-animation-container ul {
  height: auto !important;
  max-height: 200px !important;
}
.k-columnmenu-item {
  border-bottom: 1px solid #ced4da;
}
.k-animation-container ul li {
  padding: 5px 5px !important;
}
.k-animation-container ul li[aria-selected="true"] {
  background-color: $peelhunt-btn-color !important;
  color: #fff;
}
.k-columnmenu-actions button.k-button.k-primary,
.k-columnmenu-actions button.k-button.k-button-solid-primary,
.k-columnmenu-actions button.k-button.k-primary:active,
.k-columnmenu-actions button.k-button.k-primary:focus,
.k-columnmenu-actions button.k-button.k-primary.focus {
  background: $peelhunt-theme-color !important;
  border-color: $peelhunt-theme-color !important;
  outline: $peelhunt-theme-color;
}
.k-button-flat:hover {
  border-color: #cccccc;
  background: #e9ecef !important;
  border-color: transparent;
  color: #495057;
}
.k-pager-numbers .k-selected {
  color: $peelhunt-btn-color !important;
  border-color: #00b4b1 !important;
  background: #00b4b1 !important;
  color: #ffffff !important;
  min-width: 30px;
  height: 30px;
  margin: 0;
  transition: box-shadow 0.2s;
  border-radius: 3px;
}
.k-button-flat-primary {
  color: #6c757d;
}
.k-button-overlay,
.k-button::before {
  background: transparent !important;
}
.k-columnmenu-item-wrapper .k-state-selected {
  background: $peelhunt-theme-color !important;
}

.k-pager-wrap .k-link {
  color: #ccc;
  background-color: #fff;
  border: 1px solid #ccc;
  padding: 15px;
  height: 30px;
  width: 30px;
}

.k-pager-info {
  text-align: right;
  justify-content: unset;
  flex: unset;
  margin: 0;
  padding: 0;
}
.k-toolbar {
  padding: 0;
  background: #f6f6f6;
}
.table-text-one-line {
  display: -webkit-box;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
  overflow: hidden;
  max-height: 44px;
}
.k-i-sort-asc-sm.active,
.k-i-sort-desc-sm.active {
  color: $peelhunt-theme-color !important;
}
.heading-text {
  color: $peelhunt-theme-color;
  font-size: 20px;
  line-height: 1.2;
  text-transform: initial;
}
span.k-dropdownlist.k-picker.k-picker-md.k-rounded-md,
.RiskAdjustedReturn {
  height: 36px;
  z-index: 1000;
}
:not(:root):fullscreen::backdrop {
  background-color: rgba(0, 0, 0, 0.5);
  /* You might need to adjust the z-index to make sure it's below the dropdown */
  z-index: unset !important; /* Adjust as needed */
}
button.btn-secondary.disabled,
button.btn-secondary:disabled {
  cursor: not-allowed !important;
  background-color: $peelhunt-btn-color;
  border-color: $peelhunt-btn-color;
  opacity: 0.5;
}
.AllExport {
  color: $peelhunt-btn-color !important;
}
.k-list-item.k-selected,
.k-selected.k-list-optionlabel,
.k-list-item.k-selected:hover,
.k-selected.k-list-optionlabel:hover,
.k-list-item.k-selected.k-hover,
.k-selected.k-hover.k-list-optionlabel {
  color: white;
  background-color: $peelhunt-theme-color;
}
// .k-table-td {
//   padding-block: 5px !important;
// }
.peelHuntScren .tblWrapper .tableContainer .k-grid .k-grid-container,
.k-animation-container.k-animation-container-relative
  .tblWrapper
  .tableContainer
  .k-grid
  .k-grid-container {
  border: 1px solid #ced4da;
}
.no_records {
  .peelHuntScren .tblWrapper .tableContainer .k-grid .k-grid-container,
  .k-animation-container.k-animation-container-relative
    .tblWrapper
    .tableContainer
    .k-grid
    .k-grid-container {
    border: 1px solid #ced4da;
  }
  tbody tr td {
    max-height: 400px;
    width: 100%;
    height: 240px;
    text-align: center;
    border: 1px solid $peelhunt-border-color !important;
    padding: 60px 0 0 !important;
    margin: 0 !important;
    visibility: hidden;
  }
  .PricePerformanceTableData .k-grid-aria-root,
  .RiskAdjustedTableData .k-grid-aria-root {
    min-height: 400px !important;
  }
  // .customindex {
  //   .k-grid-aria-root {
  //     min-height: 300px !important;
  //   }
  // }
  .k-grid-header {
    border: 0px solid $peelhunt-border-color !important;
    padding: 0 !important;
    margin: 0 !important;
    .k-grid-header-wrap {
      border: 0px solid $peelhunt-border-color !important;
      padding: 0 !important;
      margin: 0 !important;
    }
  }
}
.no_records_chart {
  display: flex;
  height: 300px;
  width: 100%;
  flex-direction: row;
  flex-wrap: nowrap;
  justify-content: center;
  align-items: center;
  font-size: 12px;
  visibility: hidden;
}
.small-text-error {
  font-size: 10px !important;
  top: 30px;
  width: 100%;
  left: 0;
}
.table-number {
  text-align: right;
}
.k-grid-pager {
  border-top: 1px solid $peelhunt-border-color !important;
  border-bottom: 1px solid $peelhunt-border-color;
  border-left: 1px solid $peelhunt-border-color;
  border-right: 1px solid $peelhunt-border-color;
}

.k-grid.k-grid-md.no_records {
  .k-pager.k-grid-pager {
    display: none;
  }
}

.k-animation-container.k-animation-container-relative {
  z-index: 4567 !important;
}

.margin_top_40 {
  margin-top: 40px !important;
}
.lineChartWrapper {
  // max-width: 100%;
  padding: 5px;
  background: #fff;
  border: 1px solid #ccc;
  overflow: hidden;
  height: 300px;
  width: 100%;
  border-radius: 8px;
  // .svgChart {
  .plot-container {
    .svg-container {
      max-width: 100% !important;
      height: 300px !important;
      max-height: 300px !important;
      width: 100% !important;
    }
  }
  // }
}
.k-grid.k-grid-md {
  border: 0px solid $peelhunt-border-color !important;
}
.table-card {
  .k-grid {
    // border: 1px solid $peelhunt-border-color !important;
    // border-top: 0px solid $peelhunt-border-color !important;
    overflow: hidden;
    // border-radius: 8px;
    height: 300px;
  }
  table {
    width: 100% !important;
  }
  .k-grid-header {
    padding: 0 !important;
    col {
      &:nth-of-type(2) {
        text-align: right !important;
      }
      &:nth-of-type(3) {
        text-align: right !important;
      }
    }
  }
  .k-grid-table {
    col {
      &:nth-of-type(1) {
        text-align: right !important;
      }
      &:nth-of-type(2) {
        text-align: right !important;
      }
    }
  }
  .k-grid-header-wrap {
    border-top: 0px solid $peelhunt-border-color;
    border-right: 0px solid $peelhunt-border-color;
    border-bottom: 0px solid $peelhunt-border-color;
    border-left: 0px solid $peelhunt-border-color;
  }
  .k-grid th,
  .k-grid td {
    border-top: 0px solid $peelhunt-border-color !important;
    border-right: 0px solid $peelhunt-border-color !important;
    border-bottom: 0px solid $peelhunt-border-color !important;
    border-left: 0px solid $peelhunt-border-color !important;
  }
  .k-grid th:last-child {
    border-right: 0px solid $peelhunt-border-color !important;
  }
  .k-grid-header .k-header:first-child {
    border-left: 0px solid $peelhunt-border-color !important;
    border-left-width: 0px;
  }
  /* .k-grid-header .k-header {
    color: #666666 !important;
    background-color: #e2e2e2 !important;
  } */
  .k-grid td:first-child {
    border-left: 0px solid $peelhunt-border-color !important;
    border-left-width: 0px;
  }
  .k-grid td:last-child {
    border-right: 0px solid $peelhunt-border-color !important;
  }
  .k-grid tr {
    border-right: 0 solid $peelhunt-border-color !important;
  }
  .k-grid .k-grid-container {
    border-left: 1px solid $peelhunt-border-color;
    border-right: 1px solid $peelhunt-border-color;
  }
  .k-grid-pager {
    border-width: 0px 0px 0px;
    background-color: #fff;
    flex: 15 0 auto;
    a.k-link {
      display: none;
    }
    .k-pager-numbers-wrap {
      display: none;
    }
  }
}
.PricePerformanceTableData .k-grid-aria-root,
.RiskAdjustedTableData .k-grid-aria-root {
  min-height: 510px;
  height: 510px;
  max-height: 510px;
}
.k-grid .k-grid-aria-root {
  min-height: 300px;
  //   .k-grid-table-wrap {
  //     height: 100%;
  //     table.k-table.k-grid-table.k-table-md {
  //       height: 100%;
  //     }
  //   }
}
.k-grid-pager {
  border-top: 1px solid $peelhunt-border-color !important;
  border-bottom: 1px solid $peelhunt-border-color;
  border-left: 1px solid $peelhunt-border-color;
  border-right: 1px solid $peelhunt-border-color;
}
.tblWrapper table {
  border: 1px solid $peelhunt-border-color;
  .k-grid td {
    white-space: nowrap;
    overflow: hidden !important;
    text-overflow: ellipsis;
  }
}
.margin-top-25 {
  margin-top: 25px !important;
}
.k-form-field {
  width: 19%;
  max-width: 300px;
  height: 55px;
  overflow: hidden;
}
.k-label {
  margin-bottom: 0 !important;
  .kendo-label {
    color: #595959;
    font-size: 12px !important;
    font-weight: 600;
    line-height: 1.5;
    margin-left: 0 !important;
  }
}
input.RiskAdjustedReturn {
  height: 36px !important;
  margin-left: -15px !important;
  // width: 100px !important;
  // max-width: 100px !important;
  border-radius: 4px !important;
  border-color: #d4d4d4;
}
/* Chrome, Safari, Edge, Opera */
input.RiskAdjustedReturn::-webkit-outer-spin-button,
input.RiskAdjustedReturn::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}
.k-input-value-text {
  color: #333333;
}
/* Firefox */
input[type="number"].RiskAdjustedReturn {
  -moz-appearance: textfield;
}
.custom_index {
  .infoDivIcon {
    // position: absolute !important;
    top: 6px;
    right: 20px;
    z-index: 1000;
    height: 20px;
  }
}
.max-width-dropdown {
  max-width: 180px !important;
  min-width: 180px;
}
.row.dropdown-button-container {
  width: 100%;
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  align-content: flex-start;
  align-items: flex-start;
  padding: 0;
  margin-left: 0;
  justify-content: space-between;
}
button.btn-secondary.downloadBtn:focus,
button.btn-secondary.downloadBtn.focus,
.btn-secondary.downloadBtn:hover,
button.downloadBtn {
  display: unset !important;
}

#PricePerformanceId.infoDivIcon,
#RiskAdjustedReturnId.infoDivIcon {
  position: static !important;
  margin-left: 10px;
}
.tooltip-inner {
  max-width: 600px !important;
  text-align: justify !important;
  font-size: 12px !important;
  font-weight: normal !important;
  font-family: "Roboto", Arial, Helvetica, sans-serif !important;
  background: #ffffff !important;
  color: #333 !important;
  border: 1px solid silver !important;
}
// .k-columnmenu-item {
//   display: none;
// }
.k-grid-header .k-grid-filter:hover,
.k-grid-header .k-header-column-menu:hover,
.k-grid-header .k-grid-header-menu:hover,
.k-grid-header .k-hierarchy-cell .k-icon:hover,
.k-grid-header .k-hierarchy-cell .k-svg-icon:hover,
th.k-header.active > div > a {
  color: $peelhunt-btn-color !important;
  background-color: #fff;
  // background-color: $peelhunt-theme-color;
}
th.k-table-th.k-header.customMenu.active.k-filterable {
  .k-svg-icon {
    color: $peelhunt-btn-color;
  }
}
.k-grid-header .k-grid-filter:hover,
.k-grid-header .k-header-column-menu:hover,
.k-grid-header .k-grid-header-menu:hover,
.k-grid-header .k-hierarchy-cell .k-icon:hover,
.k-grid-header .k-hierarchy-cell .k-svg-icon:hover {
  color: #fff !important;
  background-color: unset !important;
  border: 1px solid #fff;
  svg {
    color: #fff !important;
  }
}
.k-pager.k-pager-md {
  button.k-button-flat {
    border: none;
  }
}
.k-pager-numbers {
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  align-items: center;
  align-content: center;
}
.k-pager-numbers-wrap button.k-button-md.k-icon-button {
  background-color: transparent;
  border: 0 none;
  color: #6c757d;
  min-width: 2.357rem;
  height: 2.357rem;
  margin: 0rem;
  //  transition: box-shadow 0.2s;
  border-radius: 3px;
}
button.k-button.k-button-md.k-icon-button.k-button-solid.k-button-solid-base.k-input-button
  span.k-svg-icon.k-button-icon {
  svg {
    display: none;
  }
  &::before {
    content: "\e931";
    font-family: primeicons !important;
    color: #6c757d;
    -ms-transform: rotate(270deg);
    -webkit-transform: rotate(270deg);
    transform: rotate(270deg);
  }
}
.k-button-flat-base.k-pager-nav.k-pager-first span.k-svg-icon.k-button-icon {
  svg {
    display: none;
  }
  &::before {
    content: "\e92d";
    font-family: primeicons !important;
    color: #6c757d;
  }
}
.k-button-flat-base.k-pager-nav:nth-child(2) span.k-svg-icon.k-button-icon {
  svg {
    display: none;
  }
  &::before {
    content: "\e931";
    font-family: primeicons !important;
    color: #6c757d;
  }
}
.k-button-flat-base.k-pager-nav span.k-svg-icon.k-button-icon {
  svg {
    display: none;
  }
  &::before {
    content: "\e932";
    font-family: primeicons !important;
    color: #6c757d;
  }
}
.k-pager-nav.k-pager-last.k-button span.k-svg-icon.k-button-icon {
  svg {
    display: none;
  }
  &::before {
    content: "\e92e";
    font-family: primeicons !important;
    color: #6c757d;
  }
}
.k-checkbox:checked:focus,
.k-checkbox.k-checked.k-focus {
  box-shadow: 0 0 0 2px #fff;
}
.k-checkbox:checked,
.k-checkbox.k-checked {
  border-color: $peelhunt-theme-color;
  color: white;
  background-color: $peelhunt-theme-color;
}
.peelhunt_kendo_table_wrapper {
  .toggle-container {
    display: flex;
    flex-direction: row;
    flex-wrap: nowrap;
    align-content: center;
    justify-content: space-around;
    align-items: center;
    margin: 0 1rem;
    p {
      margin: 0 5px 0 5px;
    }
  }
  .dropSearchAlign {
    margin-bottom: 8px;
  }
  .k-i-more-vertical::before {
    content: url("../../assets/img/icons/svg/sort.svg") !important;
    width: 35px;
    margin-top: 7px;
  }
  // switch button
  .k-switch.k-switch-md {
    width: 40px !important;
    height: 20px;
  }
  .k-switch-on .k-switch-track {
    border-color: $peelhunt-btn-color;
    color: white;
    background-color: #fff;
  }
  .k-switch-off .k-switch-thumb {
    background-color: $peelhunt-btn-color;
    border-color: $peelhunt-btn-color;
  }
  .k-switch-on .k-switch-thumb {
    // background-color: #fff;
    background-color: $peelhunt-btn-color;
    border-color: $peelhunt-btn-color;
  }
  .k-switch-md .k-switch-track {
    width: 100%;
    height: 100%;
    border: 1px solid $peelhunt-btn-color;
  }
  .k-switch-thumb-wrap {
    width: 18px;
    height: 18px;
  }
  .k-switch-md.k-switch-on .k-switch-thumb-wrap {
    left: calc(100% - 10px);
  }
  .k-switch-md.k-switch-off .k-switch-thumb-wrap {
    left: 10px;
  }
  .k-switch-md .k-switch-thumb {
    width: 100%;
    height: 100%;
  }
  .k-switch-track {
    border-width: 1px;
  }
  .k-switch-off:focus .k-switch-track,
  .k-switch-off.k-focus .k-switch-track {
    outline: none !important;
  }
  .k-switch-on:focus .k-switch-track,
  .k-switch-on.k-focus .k-switch-track {
    outline: none !important;
  }
  .k-switch-label-off {
    display: none;
  }
  .k-switch-label-on {
    display: none;
  }
  //   .k-grid-pager {
  //     display: none;
  //   }
  .k-widget.k-grid {
    padding: 20px;
    border-radius: 8px;
  }
}
.absolute-blue,
.relative-blue {
  color: $peelhunt-btn-color;
}

.column-filter-heading {
  border-bottom: 1px solid $peelhunt-border-color;
  text-align: center;
  background-color: #f3f4f5;
  padding: 5px;
}
.k-filter-menu-container {
  padding: 0px;
}
.k-list-filter {
  padding: 0 !important;
}
.k-input-solid,
.k-input-solid:focus-within {
  border: none;
  border-bottom: 1px solid $peelhunt-border-color;
  border-radius: 0;
  border-color: $peelhunt-border-color;
  box-shadow: 0 0 0 0px $peelhunt-border-color;
}
.k-popup .k-multicheck-wrap .k-item,
.k-popup .k-multicheck-wrap .k-check-all-wrap {
  padding-left: 15px !important;
}
.k-actions,
.k-edit-buttons,
.k-action-buttons,
.k-columnmenu-actions,
.k-form-buttons {
  padding: 10px 15px !important;
  border-top: 1px solid $peelhunt-border-color;
}

.column_main_wrapper {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: flex-start;
  .column_child {
    flex: 1;
    display: flex;
    flex-direction: column;
  }
}
.modal_footer_set {
  position: relative;
  background: #fff;
}
th.k-header.customMenu > div > div > span.k-i-more-vertical::before,
th.k-header.customMenu.active > div > div > span.k-i-more-vertical::before {
  content: "\e129";
}

// .k-columnmenu-item {
//   display: none;
// }
.k-columnmenu-item:focus,
.k-columnmenu-item.k-focus,
.k-button-solid-primary:focus,
.k-button-solid-primary.k-focus {
  box-shadow: none;
}
.k-columnmenu-item.k-selected {
  color: white;
  background-color: $peelhunt-btn-color;
}
.k-columnmenu-item.k-selected .k-svg-icon {
  color: #ffffff;
}

// >>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>
#modal-sm,
#new-design {
  padding-right: 10px;
  overflow-y: hidden;
  label {
    width: 100%;
    margin: 0 !important;
    cursor: pointer;
  }
  .moveable-column-wrapper {
    label {
      cursor: move;
    }
  }
  .modal-content {
    border-radius: 0px;
    border: 0px solid #fff;
    // height: 84vh;
    .modal-body {
      //   padding: 0 !important;
      .chartModalHeader {
        padding: 10px;
        .heading-text {
          font-size: 12px;
          font-weight: bold;
        }
      }
      .modal-header-blue-bg {
        background-color: $peelhunt-theme-color;
        color: #fff;
        padding: 10px;
        h5 {
          font-size: 16px;
          font-weight: 400;
        }
      }
      .search-wrapper {
        padding-bottom: 5px;
        .input-group {
          position: relative;
          display: flex;
          flex-wrap: nowrap;
          align-items: center;
          width: 90%;
          flex-direction: row;
          justify-content: flex-start;
          border: 1px solid #ccc;
          border-radius: 3px;
        }
        label.heading-label {
          font-weight: bold;
          font-size: 12px;
        }
        input {
          width: 90%;
          height: 100%;
          background: #ffffff 0% 0% no-repeat padding-box;
          border: 0px solid #bdbdbd;
          border-radius: 3px;
          border-left: 0;
          border-top-left-radius: 0;
          border-bottom-left-radius: 0;
          padding: 6px 5px;
          &:focus {
            box-shadow: none;
          }
        }
      }
      .right-side-area {
        label.heading-label {
          font-size: 12px !important;
          font-weight: bold;
          span.drag-title {
            color: #929292;
            font-size: 11px;
            font-weight: initial;
          }
        }
      }
    }
    .column-list-label {
      display: flex;
      flex-direction: row;
      flex-wrap: nowrap;
      align-content: center;
      justify-content: space-between;
      align-items: center;
      & > span {
        padding: 5px 10px !important;
        font-size: 12px;
      }
      .columnListCancel {
        height: 100%;
        padding: 7px 15px 7px 7px !important;
        background-image: url(../../assets/img/icons/svg/cancelGray.svg);
        background-repeat: no-repeat;
      }
    }
    .center-line {
      position: absolute;
      height: 100%;
      background: #cacaca;
      width: 0.1px;
      left: calc(50% - -10px);
      top: 0px;
      transform: translate(-50%, 0%);
    }
    .columns-list-container-left,
    .columns-list-container-right {
      overflow: auto;
    }
    .columns-list-container-left {
      max-height: calc(100vh - 350px);
      padding-bottom: 10px !important;
      margin-bottom: 15px;
    }
    .columns-list-container-right {
      padding-top: 2px !important;
      max-height: calc(100vh - 302px);
      .k-column-list-item {
        box-shadow: 0px 1px 4px #00000029;
      }
    }
    .k-listbox .k-list-scroller {
      border: none !important;
      padding-top: 5px;
    }
    .k-list {
      padding: 5px 10px 0 2px;
    }
    .k-list__item,
    .k-list .k-item,
    .k-list-optionlabel {
      border-radius: 4px;
      padding: 0;
      margin-bottom: 5px;
    }
    .k-item:last-child {
      // padding-bottom: 10px;
    }
    .k-listbox {
      height: unset;
    }
    .applyButton {
      color: #fff;
      height: 35px;
      border: 1px solid $peelhunt-btn-color;
      background: $peelhunt-btn-color 0% 0% no-repeat padding-box;
      border-radius: 4px;
      margin-right: 15px;
      font-size: 12px;
    }
    .resetButton {
      width: 114px;
      height: 35px;
      background: #ffffff 0% 0% no-repeat padding-box;
      border: 1px solid $peelhunt-btn-color;
      border-radius: 4px;
      color: $peelhunt-btn-color;
      font-size: 12px;
    }
  }
  span.k-checkbox-label {
    font-size: 12px !important;
  }
  .k-column-list {
    max-height: calc(100vh - 150px);
  }
  .k-column-list-item {
    padding: 5px;
    .k-checkbox:checked,
    .k-checkbox.k-checked {
      border-color: $peelhunt-theme-color;
      color: white;
      background-color: $peelhunt-theme-color;
    }
    input[type="checkbox"] {
      width: 15px;
      height: 15px;
      margin-right: 5px;
      margin-left: 5px;
    }
    .k-checkbox:focus,
    .k-checkbox.k-state-focus {
      box-shadow: unset;
    }
  }
  ::-webkit-scrollbar {
    width: 5px;
    border-radius: 3px;
  }
  ::-webkit-scrollbar-thumb {
    background: #555555;
    border-radius: 10px;
  }
  ::-webkit-scrollbar-track {
    box-shadow: inset 0 0 5px #fff;
    border-radius: 10px;
  }
}
.btn.text-left.m-1.btn-sm.btn-primary:hover a {
  color: #fff;
}
.k-pager-numbers .k-link.k-state-selected {
  color: #0a0a0a;
  background-color: #fff;
  font-weight: bold;
}
.k-pager-wrap {
  background-color: #fff;
  .k-link {
    color: #808080;
    border: 1px solid #e3e3e3;
  }
}
.k-dropdown,
.k-dropdowntree {
  background-color: #fff;
}
.k-grid-header {
  background-color: #fff;
}
.btn-primary:not(:disabled):not(.disabled):active,
.btn-primary:not(:disabled):not(.disabled).active,
.show > .btn-primary.dropdown-toggle {
  background-color: transparent;
  border-color: #fff;
  opacity: 0.9;
}
.tooltip.b-tooltip {
  opacity: 1 !important;
}
div.no_records .k-grid-aria-root div.k-grid-content.k-virtual-content {
  overflow: hidden !important;
  overflow-y: hidden !important;
}
.k-grid-content.k-virtual-content {
  overflow: auto !important;
}
// column design
#new-design {
  .k-listbox {
    width: 100%;
  }
}
.column-search {
  display: flex;
  position: absolute;
  left: 1px;
  top: 1px;
  background: white;
  width: 25px;
  z-index: 1;
  height: 29px;
  padding: 6px;
}
.input-group-addon {
  display: flex;
  padding: 8px 0px 8px 8px;
  font-size: 14px;
  font-weight: 400;
  line-height: 1;
  color: #555;
  text-align: center;
  border-right: 0;
  box-sizing: border-box;
  width: 25px;
  height: 30px;
}

.checkDisabled {
  cursor: not-allowed !important;
  * {
    cursor: not-allowed !important;
  }
}
.peelHuntScren {
  .btn-primary:not(:disabled):not(.disabled):active,
  .btn-primary:not(:disabled):not(.disabled).active,
  .show > .btn-primary.dropdown-toggle {
    background-color: unset !important;
    opacity: 0.8 !important;
    cursor: not-allowed;
  }
}
.btn-primary:not(:disabled):not(.disabled):active:focus,
.btn-primary:not(:disabled):not(.disabled).active:focus,
.show > .btn-primary.dropdown-toggle:focus,
.btn-primary:focus,
.btn-primary.focus,
.btn {
  box-shadow: unset !important;
}
.float-right {
  .text-left.m-1 {
    .dropdown-item {
      font-size: 12px;
    }
  }
}

.dropdown-item.active,
.dropdown-item:active {
  background-color: #e9ecef !important;
  color: #212529 !important;
}
.k-drag-clue {
  min-width: 150px;
  width: 100%;
  max-width: 200px;
}
.column-list-label [data-column-user-role="true"] {
  display: none !important;
}
.clickable-text-color {
  cursor: pointer;
  color: $peelhunt-theme-color;
}
.k-checkbox:disabled,
.k-checkbox.k-disabled {
  opacity: 0.5;
}
.save_selected {
  .k-column-list-item:hover,
  .k-columnmenu-item:hover {
    background-color: #fff;
  }
}
.k-pager-numbers .k-link:hover,
.k-pager-numbers .k-link.k-state-hover {
  // color: $peelhunt-theme-color;
  // background-color: unset !important;
  // opacity: 0.8;
  background: #e9ecef;
  border-color: transparent;
  color: #495057;
}
.k-pager-numbers .k-link:focus,
.k-pager-numbers .k-link.k-state-focus {
  background-color: transparent;
  box-shadow: inset 0 0 0 2px #6498d1;
}
div.k-state-selected {
  background-color: $peelhunt-theme-color !important;
}
th.k-header.active > div > div {
  color: #fff;
  background-color: $peelhunt-theme-color;
}
.modal-close-button {
  display: flex !important;
  flex-wrap: nowrap;
  justify-content: flex-end;
  align-items: center;
  height: 20px;
  padding: 0;
  img {
    width: 15px !important;
  }
}
.k-svg-icon {
  color: $peelhunt-theme-color;
}
.k-picker-solid {
  background-color: #ffffff;
  border-color: #d4d4d4;
}
// >>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>

// .k-columnmenu-item {
//   display: none;
// }

.k-columnmenu-item.k-selected .k-svg-icon {
  color: #ffffff;
}
// >>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>
// column design
.default-column-wrapper {
  .k-state-selected {
    background-color: unset !important;
    color: #424242 !important;
  }
  .k-list__item:focus,
  .k-list .k-item:focus,
  .k-list-optionlabel:focus,
  .k-list__item.k-state-focused,
  .k-list .k-state-focused.k-item,
  .k-state-focused.k-list-optionlabel {
    box-shadow: unset !important;
  }
  label {
    cursor: no-drop !important;
  }
}
.modal-dialog.modal-lg {
  .form-control {
    font-size: 12px !important;
  }
}
.v-toast__item.v-toast__item--top,
.v-toast__item.v-toast__item--bottom {
  font-size: 12px;
  font-weight: bold;
}
.v-toast__item .v-toast__text {
  padding: 0.5em 1em 0.5em 0.5em;
}
.v-toast {
  z-index: 99999;
}
.v-toast__item--error {
  background-color: #ff7655;
}
.v-toast__item--warning {
  background-color: $peelhunt-btn-color;
}
.k-grid .k-grid-header .k-filterable:first-child > .k-cell-inner .k-link {
  position: unset;
}
.k-grid .k-grid-header .k-filterable > .k-cell-inner .k-link {
  position: absolute;
  right: 32px;
}
.peelhunt_kendo_table_wrapper {
  .k-grid
    .k-grid-header
    .k-table-row:first-child
    th.k-table-th.k-header
    > .k-cell-inner
    .k-link {
    position: absolute;
    right: 13px;
  }
  .k-grid
    .k-grid-header
    th.k-table-th.k-header:first-child
    > .k-cell-inner
    .k-link {
    position: unset !important;
    text-align: left;
  }
  .k-grid .k-grid-header th.k-table-th.k-header > .k-cell-inner .k-link {
    position: absolute;
    right: 1px;
  }
  .k-grid
    .k-grid-header
    th.k-table-th.k-header.k-sorted
    > .k-cell-inner
    .k-link {
    right: 13px;
  }
  .k-grid td.k-table-td:first-child {
    position: unset;
    right: 0;
    text-align: left;
  }
  .k-grid td.k-table-td {
    position: relative;
    right: 0px;
    text-align: right;
  }
}
.RiskAdjustedTableData .peelhunt_kendo_table_wrapper .k-grid td.k-table-td {
  position: relative;
  right: 0px;
  padding-right: 25px;
}
.customindex {
  th:first-child .k-cell-inner > .k-link {
    padding-block: 8px;
    padding-inline: 12px !important;
    text-align: left;
  }
  .k-cell-inner > .k-link {
    padding-block: 8px;
    padding-inline: 20px !important;
    text-align: right;
    display: block;
  }
}
.peelHuntScren
  .tblWrapper
  .tableContainer
  .text-right-wrapper.k-grid
  div.k-grid-header {
  padding-right: 10px !important;
}
// .peelHuntScren
//   .tblWrapper
//   .tableContainer
//   .text-right-wrapper.k-grid
//   .k-grid-header::after {
//   content: "";
//   width: 10px;
//   height: unset;
//   background: white;
//   /* display: inline-block; */
//   border-top: 36px solid #00b4b1;
//   border-bottom: 36px solid #f9f9f9;
// }
li {
  display: list-item;
  text-align: -webkit-match-parent;
}
$color_1: #999;
$color_2: #555555;

.filter-container--bootstrap {
  background-color: #fff;
  border: 1px solid #ccc;
  padding: 5px 22px 5px 5px;
  .filter-selection--multiple {
    .filter-selection__rendered {
      -webkit-box-sizing: border-box;
      -moz-box-sizing: border-box;
      box-sizing: border-box;
      display: block;
      line-height: 1.428571429;
      list-style: none;
      margin: 0;
      overflow: hidden;
      padding: 0;
      width: 100%;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
    .filter-selection__choice {
      color: $color_2;
      background: #fff;
      border: 1px solid #ccc;
      border-radius: 4px;
      cursor: default;
      float: left;
      margin: 5px 5px 5px 0px;
      padding: 0 0px 0 6px;
      font-size: 12px;
    }
    .filter-selection__choice__remove {
      color: $color_1;
      cursor: pointer;
      display: inline-block;
      font-weight: bold;
      margin-right: 0;
    }
  }
  .filter-selection__clear {
    color: $color_1;
    cursor: pointer;
    float: right;
    font-weight: bold;
    margin-right: 0px;
    position: absolute;
    right: -15px;
    top: 0;
    padding: 0 5px;
    height: 25px;
    border: 1px solid #ccc;
  }
}

.gray-background {
  background-color: #f6f6f6;
}
// >>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>
</style>
